var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceactivated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 318,
    viewBox: "0 0 318 318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_562",
    x: 0,
    y: 0,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_17_5",
    "data-name": "Component 17 \\u2013 5",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_562)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562-2",
    "data-name": "Rectangle 562",
    width: 300,
    height: 300,
    transform: "translate(9 6)",
    fill: "#099"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Experience",
    transform: "translate(150 279.1)",
    fill: "#fff",
    fontSize: 48,
    fontFamily: "MyriadPro-Semibold, Myriad Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -114.384,
    y: 0
  }, "Experience")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(50 25.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_53",
    "data-name": "Union 53",
    d: "M115.706,86.776H4.226V64.2H152.632V86.776Zm0-5.872h31.086V70.069H115.706Zm.021-27.564q-3.729-2.735-7.443-5.486l.867-1.184q1.4-1.934,2.817-3.869l.1.069,3.5,2.579,3.947,2.907,7.175,5.285.163.122q-1.845,2.529-3.685,5.063Q119.441,56.076,115.727,53.341Zm12.8-1.876L117.42,43.277l-3.674-2.706q1.262-1.72,2.513-3.451,2.626-3.6,5.256-7.2l.1.079,7.443,5.476,6.034,4.445,1.309.967q-3.887,5.328-7.764,10.655ZM47.869,26.839V2.045H58.586v25.64c0,8.166,3.075,12.326,8.541,12.326,5.6,0,8.683-3.948,8.683-12.326V2.045H86.466V26.982c0,14.646-7.359,21.623-19.69,21.623C54.87,48.6,47.869,41.982,47.869,26.839ZM89.888,47.828V.988A87.256,87.256,0,0,1,104.316,0c6.586,0,11.28,1.269,14.428,3.806a13.912,13.912,0,0,1,5.041,10.988c0,4.651-1.535,8.594-4.342,11.269-3.643,3.457-9.03,5-15.338,5a25.634,25.634,0,0,1-3.643-.211V47.828Zm10.576-39.3V22.542a16.558,16.558,0,0,0,3.574.28c5.672,0,9.172-2.886,9.172-7.748,0-4.36-3.007-6.977-8.336-6.977A17.724,17.724,0,0,0,100.463,8.525Zm-67.827,39.3V11.554H32.5l-8.689,4.16L22.061,7.68,34.108,2.045h8.825V47.828ZM13.719,39.995H8.342V31.163H0V24.456H8.342V15.7h6.833v8.753h8.347v6.707H15.175v8.832Zm124.358-1.416L123.291,27.69c1.587-2.178,3.175-4.366,4.757-6.543q3.848-5.264,7.706-10.566C132.921,8.494,129.53,6,129.53,6L138.24,4,154.766.174l2.092,25.951s-3.385-2.495-6.218-4.577c-4.184,5.735-8.3,11.406-12.463,17.1Z",
    transform: "translate(71.571 81.711)",
    fill: "#099",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceactivated);
export default __webpack_public_path__ + "static/media/experienceactivated.2ac7179aca51800695f76a84bb3d7469.svg";
export { ForwardRef as ReactComponent };